/**
 *
 * @param {boolean} isQuiz - is this a quiz
 * @param {object} data - data
 * @param {object | null} [error] - error result
 * @returns {void}
 */
function passBackSubmissionState(isQuiz, data, error) {
  /**
   * NEW way: dispatchEvent 😎
   * OLD way: functions on the window that can be overwritten 🤮
   */
  const formRendererSubmitFailedEvent = new CustomEvent('formRendererSubmitFailed', {
    detail: { error },
  });
  const formRendererSubmitSuccessPassedEvent = new CustomEvent('formRendererSubmitSuccessPassed', {
    detail: { data },
  });
  const formRendererSubmitSuccessFailedEvent = new CustomEvent('formRendererSubmitSuccessFailed', {
    detail: { data },
  });
  const formRendererSubmitSuccess = new CustomEvent('formRendererSubmitSuccess', {
    detail: { data },
  });

  if (error) {
    dispatchEvent(formRendererSubmitFailedEvent);
    window.formRendererSubmitFailed(error);
    return;
  }
  if (isQuiz && data.passed) {
    dispatchEvent(formRendererSubmitSuccessPassedEvent);
    window.formRendererSubmitSuccessPassed({ data });
    return;
  }
  if (isQuiz && !data.passed) {
    dispatchEvent(formRendererSubmitSuccessFailedEvent);
    window.formRendererSubmitSuccessFailed({ data });
    return;
  }
  dispatchEvent(formRendererSubmitSuccess);
  window.formRendererSubmitSuccess({ data });
}
export default passBackSubmissionState;
